import { TextSize, Weight } from 'components'

import styled from 'styled-components'

export const ProductsPromoContainer = styled.div`
  img {
    width: 157px;
    height: auto;
  }
`

export const SmartProductItem = styled.div`
  width: 100%;
  max-width: 191px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
`

export const SmartProductsList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  padding-top: 60px;
  gap: 60px;
`
export const SmartSecureProducts = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 600px;
  justify-content: space-between;
  padding: 60px 40px;
  margin: 0 auto;
`

export const SmartSecureProductsMobile = styled.div`
  width: 100%;
  height: 292px;
  display: flex;
  flex-direction: column;
  max-width: calc(600px - 80px);
  justify-content: space-between;
  padding: 40px;
  margin: 0 auto;
`

export const SmartSecureProductsTitle = styled.span`
  width: 100%;
  font-size: ${TextSize.big};
  font-weight: ${Weight.Bold};
  line-height: 110%;
  letter-spacing: -0.8px;
`
